module.exports = "/virtual-football-league/img/amblems/right/Italy/Fake_Roma.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Italy/Fake_Roma.png
// module id = 2147
// module chunks = 4